import revive_payload_client_4sVQNw7RlN from "/var/www/html/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/html/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/html/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _00_jquery_client_6g98tXAt1O from "/var/www/html/plugins/00.jquery.client.ts";
import payload_client_yVLowv6hDl from "/var/www/html/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/var/www/html/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/var/www/html/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/html/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tbFNToZNim from "/var/www/html/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_OrkQhMqHci from "/var/www/html/node_modules/@nuxt/image-edge/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/var/www/html/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/var/www/html/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import apiTools_dktkB75FLk from "/var/www/html/plugins/apiTools.js";
import optimizely_plugin_Gr0AM4DEA6 from "/var/www/html/plugins/optimizely-plugin.js";
import iterable_client_TgvqyAlKfP from "/var/www/html/plugins/iterable.client.ts";
import _0_location_reg_flow_hash_client_2ILj4Ragae from "/var/www/html/plugins/0.location-reg-flow-hash.client.ts";
import alt_text_feature_P35l8ePB91 from "/var/www/html/plugins/alt-text-feature.ts";
import gumlet_image_error_fallback_client_UuxOnQb9oc from "/var/www/html/plugins/gumlet-image-error-fallback.client.ts";
import lazy_media_client_xzJPjE8znC from "/var/www/html/plugins/lazy-media.client.ts";
import newrelic_client_eKrrLom3qm from "/var/www/html/plugins/newrelic.client.js";
import useBootstrap_client_ouDJvcVteA from "/var/www/html/plugins/useBootstrap.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _00_jquery_client_6g98tXAt1O,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tbFNToZNim,
  plugin_OrkQhMqHci,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  apiTools_dktkB75FLk,
  optimizely_plugin_Gr0AM4DEA6,
  iterable_client_TgvqyAlKfP,
  _0_location_reg_flow_hash_client_2ILj4Ragae,
  alt_text_feature_P35l8ePB91,
  gumlet_image_error_fallback_client_UuxOnQb9oc,
  lazy_media_client_xzJPjE8znC,
  newrelic_client_eKrrLom3qm,
  useBootstrap_client_ouDJvcVteA
]